/**
 * GoalsConfigPanel - Collapsible wrapper for "Set targets" and goal configuration.
 * Expanded/collapsed controlled by parent. No business logic.
 */
import './GoalsConfigPanel.css'

function GoalsConfigPanel({ expanded, children }) {
  if (!expanded) return null
  return <div className="goalsConfigPanel">{children}</div>
}

export default GoalsConfigPanel
